import * as DialogPrimitive from '@radix-ui/react-dialog';
import { GatsbyImage } from 'gatsby-plugin-image';
import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';
import { ButtonLink } from 'src/components/Link';
import RichText from 'src/components/rich_text/RichText';
import { FieldHotspotsMarker } from '../types';

export const HotspotContent: React.FC<{
  hotspot: FieldHotspotsMarker;
}> = ({ hotspot }) => {
  const { name: title, field_text: text, field_link: link } = hotspot;
  const image = hotspot.relationships.field_media.relationships.field_media_image.gatsbyImage;

  return (
    <div>
      <GatsbyImage
        className="pds-rounded-lg"
        alt=""
        aria-hidden="true"
        objectFit="contain"
        image={image}
      />
      <DialogPrimitive.Title asChild>
        <h3 className="pds-mt-4 pds-text-title-md">{title}</h3>
      </DialogPrimitive.Title>
      <div className="pds-mt-3">
        <RichText body={text?.processed ?? ''} />
      </div>
      {link && link.url && (
        <ButtonLink
          analytics={false}
          buttonColor="neutral"
          className="pds-mt-5"
          to={link?.url}
          onClick={() => {
            sendIt({
              event: 'module_interaction',
              eventParams: {
                component_id: `primary_cta: ${link.title}`,
                component_type: 'hot_spot',
                content_name: title,
              },
            });
          }}
        >
          {link?.title}
        </ButtonLink>
      )}
    </div>
  );
};
